export const getContent = (label: string, url: string, pluginKey: string) => {
  const linkStyles = `
     color: #0B00F4;
  `;

  return `<a href="${url}" target="_blank" style="${linkStyles}" data-${pluginKey}="true">${label}</a>`;
};
